@if (userAccounts$ | async; as userAccounts) {
  <div
    (click)="userAccounts && (userAccounts?.length || 0) > 1 && onChangeAccount(userAccounts)"
    [class.cursor-pointer]="(userAccounts?.length || 0) > 1"
    class="flex flex-row items-center gap-0.5 px-1.5 py-1 hover:bg-hover rounded-md group">
    @if (activeUserAccount$ | async; as activeUserAccount) {
      @if (userAccounts.length > 1) {
        <div class="text-sm font-semibold">{{activeUserAccount.name}}</div>
      } @else if (userAccounts.length <= 1) {
        <span class="text-sm font-semibold">{{activeUserAccount.name}}</span>
      }
    }
    @if (userAccounts.length > 1) {
      <div class="rounded-lg h-full flex items-center justify-center">
        <soft-icon name="fa-solid fa-caret-down" class="text-xs opacity-90"></soft-icon>
      </div>
    }
  </div>
}
